import { makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  titleContent: {
    display: 'grid',
    gap: '24px',
    width: '100%'
  },
  label: {
    fontSize: '16px',
    fontWeight: 500,
    marginBottom: '8px',
    display: 'inline-block'
  }
})

export default useStyles
